// extracted by mini-css-extract-plugin
export default {"container":"subject_container__Tamct","Image":"subject_Image__gswbP","breadcrumb":"subject_breadcrumb__TCxgK","header":"subject_header__wwo+b","content":"subject_content__I2N1H"};